export default __webpack_public_path__ + "static/media/imageten.45a8ecb4.gif";